module.exports = __webpack_public_path__ + "img/gallery-wedding.58e3ce5a.png";